import { Separator } from "@radix-ui/react-dropdown-menu";

import { separator } from "../../css/menu";
import { styled } from "../../theme/stitches";

export const DropdownSeparator = styled(Separator, separator);
